import T from '@wojtekmaj/react-t';

import { ContentWrapper, Image, PageWrapper, Sub, Title } from './index.styles';

import VendorLogo from '../../common/vendor_logo';

import wifiIcon from '../../../static/wifi.svg';

export default function OfflinePage() {
  return (
    <PageWrapper>
      <ContentWrapper>
        <VendorLogo width={164} />
        <Image width={123} height={123} src={wifiIcon} alt="" />
        <Title>
          <T>You’re offline</T>
        </Title>
        <Sub>
          <T>Please check that you are connected to the Internet and try again.</T>
        </Sub>
      </ContentWrapper>
    </PageWrapper>
  );
}
